const MOBILE_BREAKPOINT = '(max-width: 749px)';
const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';
const ITEM_REVEAL_SELECTOR = [
  'main .product-grid__item',
  'main .resource-list__item',
  'main .collection-hub__feature-card',
  'main .collection-hub__card',
  'main .collection-hub__group-heading',
  'main .homepage-promise__item',
  'main .homepage-collection-index__item',
  'main .homepage-story-callout__media',
  'main .homepage-story-callout__content',
  'main .homepage-story-callout__detail',
  'main .section-resource-list__header',
  'footer .footer-block',
  'footer .footer__content-top',
  'footer .footer__content-bottom',
].join(',');

const SECTION_EXCLUDE_SELECTOR = [
  '.announcement-bar',
  '.homepage-banner-carousel',
  '.homepage-gift-wrap-marquee',
  '.homepage-shop-guide',
].join(',');

const observedElements = new WeakSet();

const revealObserver = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      entry.target.classList.remove('mobile-scroll-reveal--pending');
      entry.target.classList.add('mobile-scroll-reveal--visible');
      revealObserver.unobserve(entry.target);
    }
  },
  { rootMargin: '0px 0px -18% 0px' }
);

function addRevealElement(elements, element, kind) {
  if (!(element instanceof HTMLElement) || observedElements.has(element)) return;
  if (element.offsetParent === null && getComputedStyle(element).position !== 'fixed') return;

  elements.push({ element, kind });
}

function getMobileRevealElements(root = document) {
  const elements = [];
  const isDocumentRoot = root === document;
  const scope = root instanceof HTMLElement ? root : document;

  const shopGuideWrapper = document.querySelector('main .homepage-shop-guide')?.closest('.shopify-section');
  const mainWrappers = [...document.querySelectorAll('main .shopify-section')];
  const sectionStartIndex = shopGuideWrapper ? mainWrappers.indexOf(shopGuideWrapper) + 1 : 0;

  if (isDocumentRoot) {
    mainWrappers.slice(Math.max(sectionStartIndex, 0)).forEach((wrapper) => {
      const section = wrapper.querySelector(':scope > .section');

      if (section && !section.matches(SECTION_EXCLUDE_SELECTOR)) {
        addRevealElement(elements, section, 'section');
      }
    });

    document.querySelectorAll('footer .section, footer .footer, #shopify-section-footer').forEach((section) => {
      addRevealElement(elements, section, 'section');
    });
  } else {
    if (scope.matches?.('main .shopify-section > .section, footer .section, footer .footer, #shopify-section-footer')) {
      if (!scope.matches(SECTION_EXCLUDE_SELECTOR)) addRevealElement(elements, scope, 'section');
    }

    scope.querySelectorAll?.('main .shopify-section > .section, footer .section, footer .footer, #shopify-section-footer').forEach((section) => {
      if (!section.matches(SECTION_EXCLUDE_SELECTOR)) addRevealElement(elements, section, 'section');
    });
  }

  if (scope.matches?.(ITEM_REVEAL_SELECTOR)) {
    addRevealElement(elements, scope, 'item');
  }

  scope.querySelectorAll?.(ITEM_REVEAL_SELECTOR).forEach((element) => {
    addRevealElement(elements, element, 'item');
  });

  return elements;
}

function initializeMobileScrollReveal(root = document) {
  if (!matchMedia(MOBILE_BREAKPOINT).matches || matchMedia(REDUCED_MOTION).matches) return;

  const elements = getMobileRevealElements(root);

  elements.forEach(({ element, kind }, index) => {
    if (observedElements.has(element)) return;

    observedElements.add(element);
    element.classList.add('mobile-scroll-reveal', 'mobile-scroll-reveal--pending', `mobile-scroll-reveal--${kind}`);
    element.style.setProperty('--mobile-reveal-order', String(kind === 'section' ? 0 : index % 3));
    element.style.setProperty('--mobile-reveal-distance', kind === 'section' ? '28px' : '18px');
    revealObserver.observe(element);
  });
}

initializeMobileScrollReveal();

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof HTMLElement) initializeMobileScrollReveal(node);
    }
  }
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('shopify:section:load', (event) => initializeMobileScrollReveal(event.target));
